import Dialog from 'components/ReusableComponents/Dialog'
import { PMSs } from 'main/hotelBrandsAndChains'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import dashboardApi from 'services/api/dashboard'

import InputWithButton from '../../../../components/ReusableComponents/ManageHotel/InputWithButton/index'
import useCustomSearch from '../../../../hooks/useCustomSearch'
import styles from './SearchEngines.module.scss'

const SearchEngines = ({ setFormData, parentChainCode, hotelName, ...props }) => {
  const { addToast } = useToasts()

  const [isLoading, setIsLoading] = useState(false)

  const [openIHGDialog, closeIHGDialog, alertIGHDialog] = useCustomSearch(
    'IHG',
    handleIHGSearch
  )
  const [openChoiceDialog, closeChoiceDialog, alertChoiceDialog] = useCustomSearch(
    'choice',
    handleChoiceSearch
  )

  const [openWyndhamDialog, closeWyndhamDialog, alertWyndhamDialog] = useCustomSearch(
    'wyndham',
    handleWyndhamSearch
  )

  const [openMarriottDialog, closeMarriottDialog, alertMarriottDialog] = useCustomSearch(
    'marriott',
    handleMarriottSearch
  )

  const [openHiltonDialog, closeHiltonDialog, alertHiltonDialog] = useCustomSearch(
    'hilton',
    handleHiltonSearch
  )

  const [openHyattDialog, closeHyattDialog, alertHyattDialog] = useCustomSearch(
    'hyatt',
    handleHyattSearch
  )

  const [openBestWesternDialog, closeBestWesternDialog, alertBestWesternDialog] =
    useCustomSearch('bestwestern', handleBestWesternSearch)

  function handleHyattSearch(bookingEngineLink) {
    const match = bookingEngineLink.match(
      /https:\/\/www\.hyatt\.com\/en-US\/hotel\/[a-zA-Z-]+\/[a-zA-Z-]+\/([a-z]{5})/
    )

    if (match) {
      const bookingEngineLink = match[0]
      const externalHotelId = match[1]

      setFormData({
        bookingEngineLink,
        externalHotelId
      })

      closeHyattDialog()
    } else {
      alertHyattDialog('Please select another result')
    }
  }

  function handleBestWesternSearch(bookingEngineLink) {
    const externalHotelId = bookingEngineLink.match(/(?<=propertyCode\.)\d{5}/)[0]

    if (externalHotelId) {
      setFormData({
        bookingEngineLink,
        externalHotelId,
        pms: PMSs.visualmatrix
      })

      closeBestWesternDialog()
    } else {
      alertBestWesternDialog('Please select another result')
    }
  }

  function handleHiltonSearch(bookingEngineLink) {
    const match1 = bookingEngineLink.match(
      /https:\/\/www\.hilton\.com\/en\/hotels\/([a-zA-Z]{7})-/
    )

    const match2 = bookingEngineLink.match(
      /www(3)\.hilton\.com\/en\/hotels\/\w+\/[\w-]+-([A-Z]{7})\//
    )

    let match = match1 || match2

    if (match) {
      const externalHotelId = match1[1]
      const bookingEngineLink = `https://www.hilton.com/en/hotels/${externalHotelId}`

      setFormData({
        bookingEngineLink,
        externalHotelId
      })

      closeHiltonDialog()
    } else {
      alertHiltonDialog('Please select another result')
    }
  }

  function handleMarriottSearch(bookingEngineLink) {
    const match = bookingEngineLink.match(
      /marriott\.com\/(?:en-us\/)?hotels\/(?:hotel-deals)?(?:hotel-photos)?(?:hotel-reviews)?(?:event-planning\/wedding-planning)?(?:travel)?(?:local-things-to-do)?(.{5})-/
    )

    if (match) {
      const externalHotelId = match[1].toUpperCase()
      const bookingEngineLink = `https://www.marriott.com/hotels/travel/${externalHotelId}`

      setFormData({
        bookingEngineLink,
        externalHotelId
      })

      closeMarriottDialog()
    } else {
      alertMarriottDialog('Please select another result')
    }
  }

  async function handleWyndhamSearch(bookingEngineLink) {
    const match = bookingEngineLink.match(
      /wyndhamhotels\.com\/(?:[a-z]{2}-[a-z]{2}\/)?([a-zA-Z0-9-]+\/[a-zA-Z0-9-]+\/([a-zA-Z0-9-]+))\/(?:overview|rooms-rates|services-amenities|dining|local-area)/
    )

    if (match) {
      const bookingEngineSlug = match[1]

      const pageHTML = await dashboardApi.serverSideFetch(
        'wyndhamhotels.com',
        bookingEngineLink
      )

      const propertyId = pageHTML.match(/overview_propertyId = "(\d+)"/)?.[1]

      if (!propertyId) {
        alertWyndhamDialog('Please select another result')
        return
      }

      setFormData({
        bookingEngineSlug,
        externalHotelId: propertyId
      })
      closeWyndhamDialog()
    } else {
      alertWyndhamDialog('Please select another result')
    }
  }

  async function findRadissonHotelGoogle(hotelName) {
    setIsLoading(true)

    const res = await dashboardApi.serverSideFetch(
      'www.google.com',
      `https://www.google.com/search?q=${encodeURIComponent(hotelName)}`
    )

    const matches = res.match(
      /(https:\/\/www\.radissonhotels\.com[^"?]+)\?[^"?]+:([A-Z]{8})/
    )

    setIsLoading(false)

    if (matches) {
      const bookingEngineLink = matches[1]
      const externalHotelId = matches[2]

      setFormData({ bookingEngineLink, externalHotelId })
    } else {
      addToast(`Found no result`, {
        appearance: 'error',
        autoDismiss: true
      })
      alert('found no result!')
    }
  }

  function handleChoiceSearch(bookingEngineLink) {
    const match = bookingEngineLink.match(/choicehotels.com\/(.+)\/([a-z0-9]{5})?/)

    if (match) {
      const bookingEngineSlug = match[1]
      const externalHotelId = match[2].toUpperCase()

      const newBeInfo = {
        bookingEngineLink,
        bookingEngineSlug,
        externalHotelId
      }

      setFormData({ ...newBeInfo })
      closeChoiceDialog()
    } else {
      alertChoiceDialog('Please select another result')
    }
  }

  function handleIHGSearch(bookingEngineLink) {
    const match = bookingEngineLink.match(/ihg.com\/(.+)\/hotels.+\/(.+)\/hoteldetail/)

    if (match) {
      const externalHotelId = match[2].toUpperCase()

      const newBeInfo = {
        bookingEngineLink: 'https://www.' + match[0],
        bookingEngine: 'ihg',
        externalHotelId
      }

      setFormData({ ...newBeInfo })
      closeIHGDialog()
    } else {
      alertIGHDialog('Please select another result')
    }
  }

  const handlers = {
    choice: openChoiceDialog,
    ihg: openIHGDialog,
    radisson: findRadissonHotelGoogle,
    wyndham: openWyndhamDialog,
    marriott: openMarriottDialog,
    hilton: openHiltonDialog,
    hyatt: openHyattDialog,
    bestwestern: openBestWesternDialog
  }

  const Input = props => (
    <InputWithButton
      {...props}
      buttonProps={{
        onClick: () => handlers[parentChainCode](hotelName),
        disabled: !hotelName
      }}
      buttonLabel={`Find ${parentChainCode} url`}
    />
  )

  return (
    <>
      <Input {...props} />
      {isLoading && (
        <Dialog>
          <div className={styles.loading}>Getting hotel details...</div>
        </Dialog>
      )}
    </>
  )
}

export default SearchEngines
